<div class='options-chat-bubble-container'>
  <div class='content-block'>
    @if (content?.title) {
      <p class='title'>{{ content?.title }}</p>
    }
    @if (content?.subtitle) {
      <p class='message'>{{ content?.subtitle }}</p>
    }
  </div>
  <div class='options-button' (click)='openOptionsPopup()'>
    <div class='options-content'>{{ content.button }}</div>
  </div>
</div>

@if (showOptionsPopup) {
  <div class='options-list-popup'>
    <div class='options-list-container'>
      <div class='options-list-header'>
        {{ content.button }}
        <button class='close' (click)='closeOptionsPopup()'></button>
      </div>
      <div class='options-list-block'>
        @for (section of content?.sections; track section) {
          <div>
            <p class="group-title">{{ section.title }}</p>
            @for (item of section?.items; track item) {
              <mat-radio-group [(ngModel)]="selectedOption" (change)="optionSelected(item)">
                <label class='options-list-item'>
                  @if (item.title) {
                    <p class='options-list-item-title'>{{ item.title }}</p>
                  }
                  @if (item.subtitle) {
                    <p class='options-list-desc'>{{ item.subtitle }}</p>
                  }
                  <mat-radio-button [value]='item.postbackData' class='options-list-item-checkbox'></mat-radio-button>
                </label>
              </mat-radio-group>
            }
          </div>
        }
      </div>
      <div class='options-list-footer'>
        <button class='send' (click)='sendMessage()'>Send</button>
      </div>
    </div>
  </div>
}
